var chunkMapping = {
	"263": [
		263
	],
	"1255": [
		1255
	],
	"1676": [
		1676
	],
	"2168": [
		2168
	],
	"5381": [
		5381
	],
	"6307": [
		6307
	],
	"6613": [
		6613
	],
	"6693": [
		6693
	],
	"8364": [
		8364
	],
	"8825": [
		8825
	],
	"9625": [
		5603,
		2762,
		9850
	],
	"9888": [
		9888
	]
};
var idToExternalAndNameMapping = {
	"263": [
		"default",
		"./mancity/template",
		2219
	],
	"1255": [
		"default",
		"./generic/components/cards/card-news",
		2219
	],
	"1676": [
		"default",
		"./players/components/hero-player",
		2219
	],
	"2168": [
		"default",
		"./generic/components/cards/player-card",
		2219
	],
	"2762": [
		"default",
		"./generic/elements/icons",
		2219
	],
	"5381": [
		"default",
		"./mancity/components/general/seo",
		2219
	],
	"5603": [
		"default",
		"./generic/components/general/tabs",
		2219
	],
	"6307": [
		"default",
		"./generic/components/navigation/sub-header",
		2219
	],
	"6613": [
		"default",
		"./generic/elements/button",
		2219
	],
	"6693": [
		"default",
		"./generic/components/navigation/pagination",
		2219
	],
	"8364": [
		"default",
		"./generic/components/general/rich-text",
		2219
	],
	"8825": [
		"default",
		"./generic/elements/loading",
		2219
	],
	"9850": [
		"default",
		"./generic/elements/divider",
		2219
	],
	"9888": [
		"default",
		"./generic/components/general/card-slider",
		2219
	]
};
var idToRemoteMap = {
	"263": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1255": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1676": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"2168": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"2762": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5381": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5603": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6307": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6613": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6693": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8364": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8825": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9850": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9888": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"263": {
		"shareScope": "default",
		"name": "./mancity/template",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"1255": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-news",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"1676": {
		"shareScope": "default",
		"name": "./players/components/hero-player",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"2168": {
		"shareScope": "default",
		"name": "./generic/components/cards/player-card",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"2762": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"5381": {
		"shareScope": "default",
		"name": "./mancity/components/general/seo",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"5603": {
		"shareScope": "default",
		"name": "./generic/components/general/tabs",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"6307": {
		"shareScope": "default",
		"name": "./generic/components/navigation/sub-header",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"6613": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"6693": {
		"shareScope": "default",
		"name": "./generic/components/navigation/pagination",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"8364": {
		"shareScope": "default",
		"name": "./generic/components/general/rich-text",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"8825": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"9850": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 2219,
		"remoteName": "core"
	},
	"9888": {
		"shareScope": "default",
		"name": "./generic/components/general/card-slider",
		"externalModuleId": 2219,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}